export default __webpack_public_path__ + "static/media/icon-unmute.69099b62.svg";